const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.ruqqiasultanaclinic.com'
    : '';

const API_TOKEN =
  'A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2';

const AUTH = {
  accept: '*/*',
  'X-API-TOKEN': API_TOKEN,
  'Content-Type': 'application/json',
};

export const staffApi = {
  getAll: async () => {
    const r = await fetch(`${BASE_URL}/api/Patient/staff/get`, {
      headers: AUTH,
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },

  getById: async (id) => {
    const r = await fetch(`${BASE_URL}/api/Patient/staff/get-by-id/${id}`, {
      headers: AUTH,
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },

  create: async (payload) => {
    const r = await fetch(`${BASE_URL}/api/Patient/staff/create`, {
      method: 'POST',
      headers: AUTH,
      body: JSON.stringify(payload),
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },

  update: async (payload) => {
    const r = await fetch(`${BASE_URL}/api/Patient/staff/update`, {
      method: 'POST',
      headers: AUTH,
      body: JSON.stringify(payload),
    });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  },
};